<template>
  
   <router-view class="routerView"/>
  
</template>

<style>
:root {     --sl-red               : #e9525b;
            --sl-orange            : #fbbd4b;
            --sl-purple            : #b983b6;
            --sl-blue              : #2f9ba5;
            --sl-green             : #28664c;
            --sl-lightgreen        : #62923c;
            --futuretown-coldblue  : #35a8e0;
            --futuretown-blue      : #00205c;
            --futuretown-middleblue:#7DB0C0;
            --futuretown-lightblue : #E6E8EE;
            --futuretown-green     : #088573;
            --futuretown-lightgreen:#daedea;
            --futuretown-red       : #bd1622;
            --futuretown-lightred  : #fbc8c8;
            --futuretown-orange    : #f29100;
            --futuretown-lightorange:#DEB987;
          
          }
        
.green      { color: white;           background-color: var(--sl-green)      }
.blue       { color: white;           background-color: var(--sl-blue)       }
.red        { color: white;           background-color: var(--sl-red)        }
.lightgreen { color: black;           background-color: var(--sl-lightgreen) }
.lightred   { color: var(--futuretown-red); background-color: var(--futuretown-lightred) }
.white      { color: black;           background-color: white                    }
.orange     { color: white;           background-color : var(--sl-orange)    }

.redtext    {  color: var(--futuretown-red)    }
.greentext  {  color: var(--futuretown-green)  }
.yellowtext {  color: var(--futuretown-orange) }
.orangetext {  color: var(--futuretown-orange) }


#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale; 
}

@font-face {
    font-family: Fontania;
    src: url("@/assets/Fontania.otf") format("opentype");
}

@font-face {
    font-family: Countless;
    src: url("@/assets/cld.ttf");


}

.routerView {  
                margin : 10px auto auto auto;
                padding-left: 10px;
                padding-right: 10px;
                max-width: 1326px; 
                border: 1px solid black;
                font-size: 16px;    
                background-color: var(--sl-orange);
                min-height: 97vh
              }

.button {
  min-width: 100px;
  padding-left:20px;
  padding-right: 20px;
  min-height: 30px;
  border-radius: 30px;
  border: 0px;
  cursor: pointer;
  
  box-shadow: 0 0.5em 0.5em -0.4em grey;
}

.button:hover {
  box-shadow: none;
  transform: translateY(0.2em);
}
</style>
